module.exports = __webpack_public_path__ + "img/message.4d3cc0ac.jpg";